/**
 * Logs de depuración: solo se emiten con NODE_ENV=development.
 * En producción, setupConsole.ts silencia log/debug/info/warn (console.error sigue activo).
 */
const isDev = process.env.NODE_ENV === 'development';

export const devLog = (...args: unknown[]): void => {
  if (isDev) console.log(...args);
};

export const devInfo = (...args: unknown[]): void => {
  if (isDev) console.info(...args);
};

export const devWarn = (...args: unknown[]): void => {
  if (isDev) console.warn(...args);
};

export const devError = (...args: unknown[]): void => {
  if (isDev) console.error(...args);
};

export const devDebug = (...args: unknown[]): void => {
  if (isDev) console.debug(...args);
};

export const isDevEnvironment = (): boolean => isDev;
